import apiClient from '@/lib/api-client'
import type { AuthResponse, LoginCredentials, OTPResponse, RegisterCredentials } from '@/types'

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/api/v1/auth/login', credentials)
    return response.data
  },

  async register(credentials: RegisterCredentials): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/api/v1/auth/register', credentials)
    return response.data
  },

  async requestOTP(
    identifier: string,
    adminLogin = false,
    portalLogin = false,
    orgSlug?: string,
  ): Promise<OTPResponse> {
    const response = await apiClient.post<OTPResponse>('/api/v1/auth/otp/request', {
      identifier,
      admin_login: adminLogin,
      portal_login: portalLogin,
      org_slug: orgSlug,
    })
    return response.data
  },

  async verifyOTP(identifier: string, code: string, orgSlug?: string): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/api/v1/auth/otp/verify', {
      identifier,
      code,
      org_slug: orgSlug,
    })
    return response.data
  },

  async logout(): Promise<void> {
    await apiClient.post('/api/v1/auth/logout')
  },

  async getCurrentUser() {
    const response = await apiClient.get('/api/v1/auth/me')
    return response.data
  },

  async refreshToken(): Promise<{ token: string }> {
    const response = await apiClient.post('/api/v1/auth/refresh')
    return response.data
  },
}
